import { readableUrl } from './urls';

export interface ReadableArticle {
  title: string;
  url: string;
  paragraphs: string[];
}

export async function fetchReadableArticle(url: string): Promise<ReadableArticle> {
  const response = await fetch(readableUrl(url));
  if (!response.ok) throw new Error(`Readable extraction failed: ${response.status}`);
  return response.json() as Promise<ReadableArticle>;
}
